import React from "react" 
import _ from "lodash"
import { randoms } from "lib/utils"

export default function useStatements({ elemtype="opening_statements" }:{ elemtype?:string }){ 

  /** Returns a new set of statements with the additional one included */
  const addStatementToDispute = (dispute:any, statement:any, callbackFn?:any) => {
    let statements = getDisputeStatements(dispute)
    statements.push({ ...statement, parent: "[root]", level: 1, parentResult: "any" })
    return (callbackFn) ? callbackFn(statements) : statements
  }

  /** Clones a statement and then passes it to addStatementToDispute */
  const cloneStatementInDispute = (dispute:any, refstr:string, callbackFn?:any) => {
    let target = findStatementInDispute(dispute, refstr)
    console.log(target)
    if( !target ) return null
    target.refstr = randoms.string(12,"a#")
    return addStatementToDispute(dispute, target, callbackFn)
  }

  const findStatementInDispute = (dispute:any, refstr:any, callbackFn?:any) => {
    const statements = getDisputeStatements(dispute)
    let statement = statements.find( (st:any) => st.refstr === refstr )
    console.log(refstr, statement)
    if( !statement ) return null
    return ( callbackFn ) ? callbackFn(statement) : statement
  }

  const findStatementIdxInDispute = (dispute:any, refstr:any, callbackFn?:any) => {
    const statements = getDisputeStatements(dispute)
    let idx = statements.findIndex( (st:any) => st.refstr === refstr )
    if( idx === null || idx === undefined ) return null
    return ( callbackFn ) ? callbackFn(idx) : idx
  }

  const getDisputeStatements = (dispute:any) => {
    const statements = dispute.elements.find( (elem:any) => elem.refstr === elemtype )?.settings.config
    if( !statements ) return null
    return _.cloneDeep(statements)
  }

  const replaceStatementInDispute = (dispute:any, targetRefStr:string, newStatement:any, callbackFn?:any) => {
    // get index of target statement
    let targetIdx = findStatementIdxInDispute(dispute, targetRefStr)
    let removed = removeStatementFromDispute(dispute, targetRefStr)

    // put newStatement in the same index as target statement
    removed.splice(targetIdx, 0, newStatement)
    return ( callbackFn ) ? callbackFn(removed) : removed
  }

  const removeStatementFromDispute = (dispute:any, refstr:string, callbackFn?:any) => {
    let statements = getDisputeStatements(dispute).filter( (st:any) => st.refstr !== refstr )
    return ( callbackFn ) ? callbackFn(statements) : statements
  }

  const updateConditionalInDispute = (dispute:any, refstr:string, newContent:any, callbackFn?:any) => {
    let target = findStatementInDispute(dispute, refstr)
    if( !target ) return null
    target.conditional = newContent
    const statements = replaceStatementInDispute(dispute, refstr, target, callbackFn)
    return ( callbackFn ) ? callbackFn(statements) : statements
  }

  const updateConditionalLogicInDispute = (dispute:any, refstr:string, logicParam:string, value:string, callbackFn?:any) => {
    let target = findStatementInDispute(dispute, refstr)
    if( !target ) return null
    target[logicParam] = value
    const statements = replaceStatementInDispute(dispute, refstr, target, callbackFn)
    return ( callbackFn ) ? callbackFn(statements) : statements
  }

  const updateContentInDispute = (dispute:any, refstr:string, cType:string, newContent:any, callbackFn?:any) => {
    let target = findStatementInDispute(dispute, refstr)
    if( !target ) return null
    target.content[cType] = newContent
    const statements = replaceStatementInDispute(dispute, refstr, target, callbackFn)
    return ( callbackFn ) ? callbackFn(statements) : statements
  }

  const moveStatementInDispute = (dispute:any, targetIdx:number, newIdx:number, callbackFn?:any) => {
    let statements = getDisputeStatements(dispute)
    let target = statements[targetIdx]
    statements = statements.filter( (st:any) => st.refstr !== target.refstr )
    statements.splice(newIdx, 0, target)
    return ( callbackFn ) ? callbackFn(statements) : statements
  }

  const updateStatementInDispute = (dispute:any, refstr:string, newdata:any, callbackFn?:any) => {
    let target = findStatementInDispute(dispute, refstr)
    target = {...target, ...newdata}
    const statements = replaceStatementInDispute(dispute, refstr, target, callbackFn)
    return ( callbackFn ) ? callbackFn(statements) : statements
  }


  return {
    addStatementToDispute,
    cloneStatementInDispute,
    findStatementIdxInDispute,
    findStatementInDispute,
    getDisputeStatements,
    moveStatementInDispute,
    removeStatementFromDispute,
    replaceStatementInDispute,
    updateConditionalInDispute,
    updateConditionalLogicInDispute,
    updateContentInDispute,
    updateStatementInDispute
  }
}